// export const BASE_URL_ADDR = 'https://api-stream.psc.gov.ng';
// export const BASE_URL_ADDR = 'https://api-stream.psc.gov.ng';
// export const BASE_URL_ADDR = 'https://directly-talented-colt.ngrok-free.app';
export const BASE_CLOUD_ADDR = 'https://recruitment.lon1.cdn.digitaloceanspaces.com';
// export const BASE_URL_ADDR = 'https://monitored.psc.gov.ng';
// export const BASE_URL_ADDR = 'https://138.68.176.11:443';
export const BASE_URL_OCR = 'https://ocr-stream.psc.gov.ng';

export const BASE_URL_ADDR = 'https://apitunnel.psc.gov.ng';
// export const BASE_URL_ADDR = 'https://apiturret.psc.gov.ng';
